var _defs, _g, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditIcon = function SvgEditIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_406",
    "data-name": "Grupo 406",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #97d700;\n      }\n\n      .cls-3, .cls-4 {\n        stroke: none;\n      }\n\n      .cls-4 {\n        fill: #97d700;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_171",
    "data-name": "Trazado 171",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 11 13.5 L 3 13.5 C 1.621500015258789 13.5 0.5 12.37849998474121 0.5 11 L 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 L 11 0.5 C 12.37849998474121 0.5 13.5 1.621500015258789 13.5 3 L 13.5 11 C 13.5 12.37849998474121 12.37849998474121 13.5 11 13.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 3 1 C 1.897199630737305 1 1 1.897199630737305 1 3 L 1 11 C 1 12.1028003692627 1.897199630737305 13 3 13 L 11 13 C 12.1028003692627 13 13 12.1028003692627 13 11 L 13 3 C 13 1.897199630737305 12.1028003692627 1 11 1 L 3 1 M 3 0 L 11 0 C 12.65684986114502 0 14 1.34315013885498 14 3 L 14 11 C 14 12.65684986114502 12.65684986114502 14 11 14 L 3 14 C 1.34315013885498 14 0 12.65684986114502 0 11 L 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2",
    "data-name": "Icon feather-edit-2",
    className: "cls-2",
    d: "M9.067,3.592A1.144,1.144,0,0,1,10.684,5.21l-5.46,5.46L3,11.277l.607-2.224Z",
    transform: "translate(0 -0.257)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editIcon.bc629aac.svg";
export { ForwardRef as ReactComponent };